import { jsx } from "react/jsx-runtime";
import React from "react";
import PropTypes from "prop-types";
import "./BasicResult.scss";
export default function BasicResult({ message }) {
  return /* @__PURE__ */ jsx("div", { className: "actionResult", children: message });
}
BasicResult.propTypes = {
  message: PropTypes.string
};
